import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserProfile } from "../services/FirebaseUsers";

export interface UserState {
  profile: UserProfile | null;
  uid: string | null; // Firebase UID, нужен для NicknameSetup
  isLoading: boolean;
  isNewUser: boolean;
}

const initialState: UserState = {
  profile: null,
  uid: null,
  isLoading: true,
  isNewUser: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<UserProfile>) => {
      state.profile = action.payload;
      state.uid = action.payload.uid;
      state.isLoading = false;
      state.isNewUser = false;
    },
    setNewUser: (state, action: PayloadAction<string>) => {
      state.uid = action.payload;
      state.isLoading = false;
      state.isNewUser = true;
    },
    setUserLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    updateProfileField: (
      state,
      action: PayloadAction<Partial<UserProfile>>
    ) => {
      if (state.profile) {
        state.profile = { ...state.profile, ...action.payload };
      }
    },
    resetUser: () => initialState,
  },
});

export const {
  setUserProfile,
  setNewUser,
  setUserLoading,
  updateProfileField,
  resetUser,
} = userSlice.actions;

export default userSlice.reducer;
